import React from 'react'

import noop from 'lodash/noop'

import cn from '../../libs/class-names'

import CheckboxField from '../checkbox-field/checkbox-field'

export interface Props {
  classNames?: string[]
  label: React.ReactNode
  badge?: React.ReactNode
  price?: string
  selected?: boolean
  multiple?: boolean
  headlineItem?: boolean
  onClick?: React.MouseEventHandler
}

const SelectMenuItem = React.forwardRef(
  (
    {
      classNames,
      label,
      selected = false,
      multiple = false,
      headlineItem = false,
      onClick = noop,
      badge,
      price,
    }: Props,
    ref: React.ForwardedRef<HTMLButtonElement>
  ) => {
    const handleClick = (event: React.MouseEvent) => {
      event.preventDefault()
      onClick(event)
    }

    return (
      <button
        ref={ref}
        type="button"
        disabled={headlineItem}
        className={cn('SelectMenuItem', {selected, headlineItem}, classNames)}
        onClick={!headlineItem ? handleClick : undefined}
      >
        {multiple && (
          <span className="SelectMenuItem__checkbox">
            <CheckboxField checked={selected} />
          </span>
        )}
        <span className="SelectMenuItem__label">{label}</span>
        {badge && <span className="SelectMenuItem__badge">{badge}</span>}
        {price && <span className="SelectMenuItem__price">{price}</span>}
      </button>
    )
  }
)

SelectMenuItem.displayName = 'SelectMenuItem'

export default SelectMenuItem
